module.exports = __webpack_public_path__ + "img/24775412000161.bd534c73.png";